<!-- Нижнее окно: выезд, свайп вниз, затемнение — SheetDirective -->
<div class="basket-dialog-container" [appSheet]="scrollContent" (sheetClosed)="onSheetClosed()">

  <!-- Ручка: окно закрывается свайпом вниз -->
  <div class="sheet-grabber"></div>

  <div class="basket-dialog-header">
    <p class="basket-title">{{ 'basket' | translate }}</p>
    <button mat-icon-button class="close-button" (click)="close(); $event.stopPropagation()">
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>
  <div class="basket-dialog-content" #scrollContent>
    <!-- Аллергия: сообщить официанту (если в меню указаны аллергены) -->
    <app-allergy-notice class="allergy-notice"></app-allergy-notice>

    <!-- Ваше содержимое корзины -->
    <div *ngIf="foods && foods.length">
        <app-basket-food-card
         *ngFor="let food of foods; let last = last"
         [food]="food"
         [isLast]="last && drinks != null && drinks.length === 0"
        ></app-basket-food-card>
    </div>
    <div *ngIf="drinks && drinks.length">
      <app-basket-drink-card
       *ngFor="let drink of drinks; let last = last"
       [drink]="drink"
       [isLast]="last"
      ></app-basket-drink-card>
    </div>
    <div class="basket-dialog-footer"></div>
  </div>

  <!-- Create or update order. Внутри окна — едет вместе с ним при свайпе -->
  <app-menu-basket-order></app-menu-basket-order>
</div>
